import React, { useEffect } from 'react';
import './app.scss';
import { IRootStore } from './services/RootStore';
import { EFetchState } from './services/NotificationService';
import { runInAction } from 'mobx';
import { useGetMeQuery } from 'API/BaseApi';
import type { FCWithChildren } from '../types/FCWithChildren';

export const TitleReportAuthWrapper: FCWithChildren<{ rootStore: IRootStore }> = ({ rootStore, children }) => {
  const { isError } = useGetMeQuery();

  useEffect(() => {
    if (!isError && rootStore.notifications && rootStore.appData) {
      runInAction(() => {
        rootStore.appData!.isAuthorized = true;
      });
      rootStore.notifications.setAuthState(EFetchState.SUCCESS);
    }
  }, [isError, rootStore]);
  return <>{children}</>;
};
